import { IconBox } from "@common/components";
import { AUTH_ROUTES } from "@domains/auth/routes";
import { Prohibit } from "@phosphor-icons/react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const UnauthorizedPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      navigate(AUTH_ROUTES.SIGN_OUT.path);
    }, 5000);
  });

  return (
    <div className="flex h-[100vh] w-full flex-col items-center justify-center space-y-4">
      <IconBox>
        <Prohibit className="size-8" />
      </IconBox>
      <div className="font-serif text-3xl">401 Unauthorized</div>
      <p className="text-xl">
        An unexpected error has occurred. You will be redirected to the login
        page in 5 seconds.
      </p>
    </div>
  );
};
